import { gql } from "lib/apolloClient";
import { projectAttachmentFragment } from "UnitPlans/modules/UnitPlanFragments";

export const createDeadlineV2Mutation = gql`
  mutation createDeadlineV2Mutation($input: CreateProjectGroupTaskInput!) {
    project {
      createTask(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const deleteDeadlineV2Mutation = gql`
  mutation deleteDeadlineV2Mutation($input: DeleteProjectGroupTaskInput!) {
    project {
      deleteTask(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateDeadlineV2Mutation = gql`
  mutation updateDeadlineV2Mutation($input: UpdateProjectGroupTaskInput!) {
    project {
      updateTask(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateProjectDeadlineMutation = gql`
  mutation updateProjectTask($input: UpdateProjectTaskInput!) {
    project {
      updateProjectTask(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateProjectDeadlineSubmissionMutation = gql`
  mutation updateProjectSubmission($input: UpdateProjectSubmissionInput!) {
    project {
      updateProjectSubmission(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const deleteAttachmentMutation = gql`
  mutation deleteAttachments($attachmentIds: [ID]!) {
    platform {
      deleteAttachments(attachmentIds: $attachmentIds) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateAttachmentMutation = gql`
  mutation updateAttachment($input: AttachmentUpdateInput!) {
    platform {
      updateAttachment(input: $input) {
        ...attachmentItemV2
      }
    }
  }
  ${projectAttachmentFragment.attachment}
`;

export const updateSubmissionItemResponseMutation = gql`
  mutation UpdateProjectTaskSubmissionItemResponseResponse(
    $input: UpdateProjectTaskSubmissionItemResponseInput!
  ) {
    project {
      updateSubmissionItemResponse(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
